export default {
  protocol: {},
  protocols: [],
}
